import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useRBAC } from "../context/rbac/RBACContext";

/**
 * Landing for `/:machineId` — redirects to the role-specific home or unauthorized.
 */
const MachineIndexRoute = () => {
	const { machineId } = useParams();
	const location = useLocation();
	const { resolveMachineHomeUrl, loading } = useRBAC();

	if (loading) {
		return null;
	}

	const target = resolveMachineHomeUrl(machineId);
	if (target && location.pathname !== target) {
		return <Navigate to={target} />;
	}

	return <Navigate to="/unauthorized" replace />;
};

export default MachineIndexRoute;
